import { MS_PER_DAY, startOfDay, toDateKey } from './dates.js';
function parseBirthdayParts(birthday) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthday.date);
    if (!match)
        return null;
    return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
}
/**
 * Age on `on`. Feb-29 birthdays are counted on Mar 1 in common years — the same rule the
 * next-occurrence calculation uses, so "turns 17" and the date it shows on agree.
 */
export function computeAge(birthday, on = new Date()) {
    if (!birthday.yearKnown)
        return null;
    const parts = parseBirthdayParts(birthday);
    if (!parts)
        return null;
    let age = on.getFullYear() - parts.year;
    const hadBirthday = on.getMonth() + 1 > parts.month ||
        (on.getMonth() + 1 === parts.month && on.getDate() >= parts.day);
    if (!hadBirthday)
        age -= 1;
    return age;
}
/** The next date this birthday falls on, at or after `from` (local midnight). */
export function nextBirthdayDate(birthday, from = new Date()) {
    const parts = parseBirthdayParts(birthday);
    if (!parts)
        return null;
    const today = startOfDay(from);
    for (let yearOffset = 0; yearOffset <= 1; yearOffset += 1) {
        const year = today.getFullYear() + yearOffset;
        const candidate = new Date(year, parts.month - 1, parts.day);
        // Feb 29 in a common year rolls to Mar 1 (JS already does this on construction).
        if (candidate.getTime() >= today.getTime())
            return startOfDay(candidate);
    }
    return null;
}
export function upcomingBirthdays(birthdays, options = {}) {
    const now = options.now ?? new Date();
    const today = startOfDay(now);
    const withinDays = options.withinDays ?? 365;
    const out = [];
    for (const birthday of birthdays) {
        const next = nextBirthdayDate(birthday, today);
        if (!next)
            continue;
        const daysUntil = Math.round((next.getTime() - today.getTime()) / MS_PER_DAY);
        if (daysUntil > withinDays)
            continue;
        out.push({
            birthday,
            date: toDateKey(next),
            daysUntil,
            turningAge: computeAge(birthday, next),
        });
    }
    out.sort((a, b) => a.daysUntil - b.daysUntil || a.birthday.name.localeCompare(b.birthday.name));
    return options.limit === undefined ? out : out.slice(0, options.limit);
}
/** Birthdays landing on a given local `YYYY-MM-DD` — the month grid's hollow dot. */
export function birthdaysOnDay(birthdays, dateKey) {
    const day = new Date(`${dateKey}T00:00:00`);
    return upcomingBirthdays(birthdays, { now: day, withinDays: 0 });
}
/** "Ezry turns 17" / "Grandma Jo's birthday" when the year is unknown. */
export function birthdayHeadline(entry) {
    return entry.turningAge === null
        ? `${entry.birthday.name}'s birthday`
        : `${entry.birthday.name} turns ${entry.turningAge}`;
}
/** "Today" / "Tomorrow" / "9 days out". */
export function birthdayCountdown(entry) {
    if (entry.daysUntil === 0)
        return 'Today';
    if (entry.daysUntil === 1)
        return 'Tomorrow';
    return `${entry.daysUntil} days out`;
}
//# sourceMappingURL=birthdays.js.map